import { FC, PropsWithChildren } from 'react';

import { cardRecipe } from './Card.css';
import { getClassNames } from '../../util/css';
import { RecipeVariants } from '../../vanilla-extract.css';
import { Box } from '../Box/Box';

type CardProps = RecipeVariants<typeof cardRecipe> & {
  as?: Extract<keyof JSX.IntrinsicElements, 'section' | 'div'>;
  className?: never;
};

type CompoundCardProps = {
  Content: typeof Content;
};

const sparkyClassName = 'sparky-card';

export const Card: FC<PropsWithChildren<CardProps>> & CompoundCardProps = ({
  children,
  as: TagName = 'div',
  corners,
  elevation,
  overflow,
  display,
  className = '',
}) => {
  const classNames = getClassNames(sparkyClassName, cardRecipe({ corners, elevation, overflow, display }), className);
  return <TagName className={classNames}>{children}</TagName>;
};

Card.toString = () => `.${sparkyClassName}`;
Card.displayName = 'Card';

const Content: FC<PropsWithChildren<unknown>> = ({ children }) => {
  return <Box padding="10">{children}</Box>;
};

Card.Content = Content;
Card.Content.displayName = 'Card.Content';
